import { Typography, Box} from '@mui/material';
import Header from '../components/layout/Header';
import EventsSection from '../components/sections/EventsSection';
import Footer from '../components/layout/Footer';
import AdsSlide from '../components/sections/AdsSlide';

const Home = () => {

  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Header />

      <AdsSlide />
      <Box sx={{ flexGrow: 1, px: 3, mt: 3 }}>
        <Typography variant="h2" component="h1" mb={{ xs: 2.5, sm: 3, md:5 }} ml={{ md: 5 }}>Évènements</Typography>
        <EventsSection />
      </Box>
      <Footer />
    </Box>
  );
};

export default Home;